



import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaPencil,
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";
import { handleAxiosError } from "../Utility/handleAxiosError";
const AdminApplicationView = () => {
    const navigate = useNavigate();
  const dispatch = useDispatch();
const location = useLocation();

  const data = location.state?.data;

  console.log(data)

  const [formData, setFormData] = useState({
    forceNumber: "",
    forceName:"",
    service:"",
    type:"",
    rank:"",
    fullName: "",
    medicalCategory: "",
    dateOfDischarge: "",
    dischargeBookNo: "",
    unitRetired: "",
    fatherName: "",
    motherName: "",
    dob: "",
    spouseName: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    address: "",
    pinCode: "",
    email: "",
    mobile: "",
    altMobile: "",
    otp: "",
    appId:"",
    action:"",
    remarks:""
  });

  const [dischargeFile, setDischargeFile] = useState(null);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [forces, setForces] = useState([]);
  const [services, setServices] = useState([]);
  const [types, setTypes] = useState([]);
  const [ranks, setRanks] = useState([]);
const [pdfSrc, setPdfSrc] = useState(null);
const [showModal, setShowModal] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState("");


  const fetchData = async () => {
      
      try {
        
        setFormData(data);
        setDistricts([data.district])
        setStates([data.state])
        setTehsils([data.tehsil])
        setForces([data.forceName])
        setServices([data.service])
        setTypes([data.type])
        setRanks([data.rank])
        
       
      } catch (error) {
        handleAxiosError(error);
      } finally {
        dispatch(isloading());
      }
    };
 useEffect(() => {
  dispatch(isloading());
     fetchData();
  }, [dispatch]);


  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "action" && value === "approve") {
    setFormData(prev => ({
      ...prev,
      action: value,
      remarks: "" 
    }));
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};

  const handleStateChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, state: value, district: "" }));
  };

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
  const maxSizeInBytes = 1 * 1024 * 1024;

  if (!allowedTypes.includes(file.type)) {
    toast.error("Invalid file type. Only PDF, PNG, and JPG are allowed.");
    e.target.value = ""; 
    return;
  }

  if (file.size > maxSizeInBytes) {
    toast.error("File size should not exceed 1MB.");
    e.target.value = ""; 
    return;
  }

  setDischargeFile(file); 
};




  const handleSubmit = async () => {

   
    try {
      
      const registerRes = await AxiosInstance.post(
        `${BaseUrl}/api/admin/action-skill-registration`,
         {status: formData.action ==="approve" ? "APPROVED":"REJECTED",
            remarks:formData.remarks,
            appId:formData.appId
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (registerRes.data?.status === 200) {
       toast.success(registerRes.data.message);
       navigate("/dashboard/registration-data")
      } else {
        toast.error(registerRes.data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Registration failed");
    }
  };



  const viewDocument=async()=>{
     try {

        const res = await AxiosInstance.get(`${BaseUrl}/api/auth/view-discharge-pdf/${formData.id}`,
           {
          // params:{id:formData.id},
          headers: { 'Content-Type': 'application/json' },
           responseType: 'arraybuffer', 
        });

         const blob = new Blob([res.data], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    setPdfSrc(pdfUrl); 
    setShowModal(true); 
        
    } catch (err) {
      toast.error(err.response?.data?.message || "Server error");
    } finally {
    }
  }
  return (
  
        <div className="home-dashboard">
          <div className="ticket-tab">
        <h3 >
          Service Member Registration Form
        </h3>
        <form
          encType="multipart/form-data"
          className="needs-validation"
        >
          <h5 className="mb-3 border-bottom pb-2 text-secondary border-info">
            Personal & Service Information
          </h5>
          <div className="row">
{/* <div className="col-md-6 mb-3">
              <label className="form-label">Force</label>
              <select
                className="form-select"
                name="forceName"
                value={formData.forceName}
                
                required
                disabled
              >
                <option value="">Select Force</option>
                {forces.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div> */}
{/* <div className="col-md-6 mb-3">
              <label className="form-label">Service</label>
              <select
                className="form-select"
                name="service"
                value={formData.service}
                
                required
                disabled
              >
                <option value="">Select Service</option>
                {services.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div> */}
             {/* <div className="col-md-6 mb-3">
              <label className="form-label">Type</label>
              <select
                className="form-select"
                name="type"
                value={formData.type}
                
                required
                disabled
              >
                <option value="">Select Type</option>
                {types.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div> */}
             {/* <div className="col-md-6 mb-3">
              <label className="form-label">Rank</label>
              <select
                className="form-select"
                name="rank"
                value={formData.rank}
                
                required
                disabled
              >
                <option value="">Select Rank</option>
                {ranks.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div> */}


            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Force/Service Number</label>
              <input
                type="text"
                className="form-control"
                name="forceNumber"
                value={formData.forceNumber}
                
                required
                disabled
              />
            </div> */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Full Name</label>
              <input
                type="text"
                className="form-control"
                name="fullName"
                value={formData.fullName}
                
                required
                disabled
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Medical Category</label>
              <input
                type="text"
                className="form-control"
                name="medicalCategory"
                value={formData.medicalCategory}
                
                required
                disabled
              />
            </div> */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Date of Discharge/Retirement</label>
              <input
                type="date"
                className="form-control"
                name="dateOfDischarge"
                value={formData.dateOfDischarge}
                
                required
                disabled
                onKeyDown={(e) => e.preventDefault()}
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Discharge Book No</label>
              <input
                type="text"
                className="form-control"
                name="dischargeBookNo"
                value={formData.dischargeBookNo}
                
                required
                disabled
              />
            </div> */}
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Name of Unit Retired From</label>
              <input
                type="text"
                className="form-control"
                name="unitRetired"
                value={formData.unitRetired}
                
                required
                disabled
              />
            </div> */}
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">
                Upload Discharge/Retirement Book
              </label>

              <button type="button" className="btn btn-primary" onClick={viewDocument} >View Discharge/Retirement Book</button>
             
            </div> */}
          </div>

          <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
            Family Details
          </h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Father's Name</label>
              <input
                type="text"
                className="form-control"
                name="fatherName"
                value={formData.fatherName}
                
                required
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Mother's Name</label>
              <input
                type="text"
                className="form-control"
                name="motherName"
                value={formData.motherName}
                
                required
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                value={formData.dob}
                
                required
                disabled
                 onKeyDown={(e) => e.preventDefault()}
              />
            </div>
            {/* <div className="col-md-6 mb-3">
              <label className="form-label">Spouse Name</label>
              <input
                type="text"
                className="form-control"
                name="spouseName"
                value={formData.spouseName}
                
                disabled
              />
            </div> */}
          </div>

          <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
            Address Details
          </h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">State</label>
              <select
                className="form-select"
                name="state"
                value={formData.state}
                onChange={(e)=>{handleStateChange(e);}}
                required
                disabled
              >
                <option value="">Select State</option>
                {states?.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
             
            <div className="col-md-6 mb-3">
              <label className="form-label">District</label>
              <select
                className="form-select"
                name="district"
                value={formData.district}
                
                required
                disabled
              >
                <option value="">Select District</option>
                {districts?.map((dist) => (
                  <option key={dist} value={dist}>
                    {dist}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Tehsil</label>
              
               <select
                className="form-select"
                name="tehsil"
                value={formData.tehsil}
                
                required
                disabled
              >
                <option value="">Select Tehsil</option>
                {tehsils?.map((dist) => (
                  <option key={dist} value={dist}>
                    {dist}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Village/Ward No</label>
              <input
                type="text"
                className="form-control"
                name="village"
                value={formData.village}
                
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Permanent Home Address</label>
              <textarea
                className="form-control"
                rows={2}
                name="address"
                value={formData.address}
                disabled
                
              ></textarea>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">PIN Code</label>
              <input
                type="text"
                className="form-control"
                name="pinCode"
                value={formData.pinCode}
                disabled
                
              />
            </div>
          </div>

          <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
            Contact Information
          </h5>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Email ID</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Mobile Number</label>
              <input
                type="text"
                className="form-control"
                name="mobile"
                value={formData.mobile}
                
                required
                
                disabled
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Alternate Mobile Number</label>
              <input
                type="text"
                className="form-control"
                name="altMobile"
                value={formData.altMobile}
                
                required
                disabled
              />
            </div>
          </div>
          <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
  Qualification Details
</h5>
<div className="row">
  <div className="col-12">
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Institution Name</th>
            <th>Board/University</th>
            <th>Qualification Type</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {formData.qualification?.map((qual, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{qual.institutionName || 'N/A'}</td>
              <td>{qual.board || 'N/A'}</td>
              <td>{qual.type || 'N/A'}</td>
              <td>{qual.percentage ? `${qual.percentage}%` : 'N/A'}</td>
            </tr>
          ))}
          {(!formData.qualification || formData.qualification.length === 0) && (
            <tr>
              <td colSpan="5" className="text-center">No qualification details available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>
        <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
            Action
          </h5>
           <div className="row">
  <div className="col-md-6 mb-3 ">
    <div className="form-check form-check-inline">
      <input
        type="radio"
        className="form-check-input"
        id="approve"
        name="action"
        value="approve"
        checked={formData.action === "approve"}
        onChange={handleChange}
        required
      />
      <label className="form-check-label" htmlFor="accept">Accept</label>
    </div>
    <div className="form-check form-check-inline">
      <input
        type="radio"
        className="form-check-input"
        id="reject"
        name="action"
        value="reject"
        checked={formData.action === "reject"}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="reject">Reject</label>
    </div>
  </div>
</div> 

{formData.action === "reject" && (
  <div className="row">
    <div className="col-md-12 mb-3">
      <label className="form-label">Remarks</label>
      <textarea
        className="form-control"
        name="remarks"
        value={formData.remarks || ""}
        onChange={handleChange}
        placeholder="Enter reason for rejection"
        required
      />
    </div>
  </div>
)}
      {formData.action &&   <div className="row">
  <div className="col-md-2 mb-3">
    <button
      type="button"
      className="btn btn-primary"
      disabled={!formData.action} 
      onClick={handleSubmit}
    >
      Submit
    </button>
  </div>
</div> }
        </form>
      </div>

    <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="lg">
  <ModalHeader toggle={() => setShowModal(false)}>Discharge/Retirement Book</ModalHeader>
  <ModalBody style={{ height: "80vh", padding: 0 }}>
    {pdfSrc && (
      <embed
        src={pdfSrc}
        type="application/pdf"
        width="100%"
        height="100%"
      />
    )}
  </ModalBody>
</Modal>


        </div>
  
  );
};

export default AdminApplicationView;
